import React, { forwardRef } from "react";
import styled from "styled-components";
import { MoreHorizontal } from "lucide-react";
import { getNewLookTokens, NEW_LOOK_RADIUS } from "common/NewLook/tokens.ts";

interface ActionsTriggerProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  label: string;
}

/** New look: the ⋯ menu trigger of a backtest (row or card), a real button. */
const ActionsTrigger = forwardRef<HTMLButtonElement, ActionsTriggerProps>(
  ({ label, ...props }, ref) => (
    <Trigger
      ref={ref}
      type="button"
      aria-label={label}
      title={label}
      data-bt-actions={true}
      {...props}
    >
      <MoreHorizontal size={18} strokeWidth={1.75} />
    </Trigger>
  )
);
ActionsTrigger.displayName = "ActionsTrigger";

export default ActionsTrigger;

const Trigger = styled.button`
  flex: none;
  width: 32px;
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: none;
  border-radius: ${NEW_LOOK_RADIUS.control}px;
  background: transparent;
  color: ${(p) => getNewLookTokens(p.theme).secondary};
  cursor: pointer;
  transition: background-color 120ms, color 120ms;
  &:hover,
  &.ant-dropdown-open {
    color: ${(p) => getNewLookTokens(p.theme).ink};
    background: ${(p) => getNewLookTokens(p.theme).well};
    box-shadow: inset 0 0 0 1px ${(p) => getNewLookTokens(p.theme).hairline};
  }
  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 2px ${(p) => getNewLookTokens(p.theme).focus};
  }
`;
